var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableSearchFieldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 11.9C13.475 12.3 13.475 12.925 13.1 13.325C12.7 13.7 12.075 13.7 11.675 13.325L8.7 10.325C7.675 11 6.425 11.35 5.075 11.175C2.775 10.85 0.925 8.975 0.625 6.7C0.2 3.3 3.075 0.425 6.475 0.85C8.75 1.15 10.625 3 10.95 5.3C11.125 6.65 10.775 7.9 10.1 8.9L13.1 11.9ZM2.575 6C2.575 7.775 4 9.2 5.775 9.2C7.525 9.2 8.975 7.775 8.975 6C8.975 4.25 7.525 2.8 5.775 2.8C4 2.8 2.575 4.25 2.575 6Z",
    fill: "#8A94AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSearchFieldIcon);
export default __webpack_public_path__ + "static/media/table-search-field-icon.17c7359dc279f8448dd69ad564ca7b51.svg";
export { ForwardRef as ReactComponent };